import { useLazyGetQRCodeQuery } from '../api';

export const useQRCode = (order_hash: string) => {
  const [getQRCode, { data: qrCode, isLoading, isError, error }] = useLazyGetQRCodeQuery();

  return {
    getQRCode,
    qrCode,
    isError,
    error,
    isLoading,
  };
};
